import { AbstractDataSource } from './AbstractDataSource';
import { ArrayDataSource } from './ArrayDataSource';
import { ResourceDataSource } from './ResourceDataSource';
import { StoreDataSource } from './StoreDataSource';

export default {
    AbstractDataSource, ArrayDataSource, ResourceDataSource, StoreDataSource
};
